<supplier-schedule-dialog
  *mobxAutorun="{}"
  [jobId]="jobId"
  [taskId]="taskId"
  [taskScheduleSource]="taskScheduleSource"
  [visible]="visible"
  [autoEdit]="true"
  [referrPage]="referrPage"
  (visibleChange)="visibleChange.emit($event)"
  (confirm)="saveTaskSupplierSchedule($event)"
  finalBtnText="Update"
>
</supplier-schedule-dialog>
